// Global beaconLocations object to store beacon positions for Cesium 3D view
const beaconLocations: {
  [id: string]: { lon: number; lat: number; alt: number };
} = {};

// Methods object with addReferenceBeacon as described
const methods = {
  addReferenceBeacon: function (beacon: any, alt: number) {
    if (beacon.geometry && beacon.geometry.coordinates) {
      beaconLocations[beacon.id] = {
        lon: beacon.geometry.coordinates[0],
        lat: beacon.geometry.coordinates[1],
        alt: alt,
      };
    }
  },
};
import { Injectable } from '@angular/core';
import _ from 'lodash';
import * as turf from '@turf/turf';
import { FacilityPinMapEntity } from './facility-pin.service';
import { DataContextService } from './data-context.service';
import { BuildingMapEntity } from './building-map-entity-test';
import { AreaMapEntity } from './area-map';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { IncidentCategory } from '../models/incident-category.model';
import { ApiService } from './api.service';
import { ConfigurationManagerService } from './configuration-manager.service';
import { Organization } from '../models/model';
import { CameraService } from './camera.service';
import { CoreService } from './core.service';
import { CoresService } from './cores.service';
import { BuildingTilesService } from './building-tile.service';
import { Sensor } from './sensor.service';
import { PerimeterMapEntity } from './PerimeterMapEntity.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimelineService } from './timeline.service';
import { ThreeIntegrationService } from './three-js-building.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationUtilService {
  public buildingRows: any[] = [];
  public foreverEntitiesAdded: {
    perimeters: Record<string, any>;
    facilities: Record<string, any>;
    remotes: Record<string, any>;
    areas: Record<string, any>;
    campus: Record<string, any>;
  } = {
    perimeters: {},
    facilities: {},
    remotes: {},
    areas: {},
    campus: {},
  };
  data: any = {
    papiPerimeters: {},
    myBluetoothFacilityPins: {},
    myFacilityPins: {},
    myBuildings: [],
    perimeterAreaMap: {},
    myPerimeters: {}, // this is the perimeters that are used in the map
    myBeaconsById: {},
    myBeacons: {},
    myPerimetersForOrg: [],
    userStatusByIncidentLast: {},
    playbackBuildingViewDataDict: {},
  };

  buildingPromises: any[] = [];
  private _myPerimetersForOrg: any[] = [];
  public myOrgs: Record<string, Organization> = {};

  private isCampusIncident = new BehaviorSubject<boolean>(false);
  isCampusIncident$: Observable<boolean> = this.isCampusIncident.asObservable();
  
  constructor(
    private dataContextService: DataContextService,
    private api: ApiService,
    private cameraService: CameraService,
    private coreService: CoreService,
    private coresService: CoresService,
    private buildingTilesService: BuildingTilesService,
    private windowService: WindowService,
    private modalService: NgbModal,
    private timelineService: TimelineService,
    private threeJsBuildingIntegration: ThreeIntegrationService,
  ) {}

  get myPerimetersForOrg(): any[] {
    return this._myPerimetersForOrg;
  }

  get perimeters(): { [key: string]: any } {
    return this.foreverEntitiesAdded.perimeters;
  }
  getCampusBuildingPerimeters(myCampus: any): any[] {
    const result: any[] = [];

    const campuses = Array.isArray(myCampus) ? myCampus : myCampus?.campuses;

    if (!Array.isArray(campuses)) {
      return result;
    }

    campuses.forEach((campus: any) => {
      const campusId = campus.campusId;

      if (!Array.isArray(campus.buildings)) {
        return;
      }

      campus.buildings.forEach((building: any) => {
        result.push({
          campusId: campusId,
          buildingId: building.buildingId
        });
      });
    });

    return result;
  }

  async processOrganizations(
    results: any,
    orgPerimetersData: any,
    perimeter: any,
    campus: any
  ) {
    const mydata: any = {};
    this.foreverEntitiesAdded = {
      perimeters: {},
      facilities: {},
      remotes: {},
      areas: {},
      campus: {},
    };

    // Reset data to initial empty state
    this.data = {
      papiPerimeters: {},
      myBluetoothFacilityPins: {},
      myFacilityPins: {},
      myBuildings: [],
      perimeterAreaMap: {},
      myPerimeters: {},
      myBeaconsById: {},
      myBeacons: {},
      myPerimetersForOrg: [],
      userStatusByIncidentLast: {},
      myCampus: [],
    };
    mydata.myName = '';
    mydata.myId = 1;
    mydata.myPermissions = {}; // no longer used
    mydata.myOrgs = {};
    mydata.facilityPin = {};
    mydata.myBuildings = [];
    mydata.myBluetoothFacilityPins = {};
    mydata.perimeterAreaMap = {};
    mydata.myOrgIds = (results.orgs?.rows || []).map((org: any) => org.id);
    mydata.papiPerimeters = {};
    this.data.myCampus = campus;
    this.buildingRows = results.BuildingFindAndCountAll?.rows || [];
    this.data.myCampus = campus;
    const campusBuildingPerimeters =
    this.getCampusBuildingPerimeters(this.data.myCampus);

    this.data.myCampusBuildingPerimeters = campusBuildingPerimeters;

    _.forEach(results.orgs.rows, (orgData: any) => {
      const safezones: any[] = [];
      const facilities: any[] = [];
      const campus: any[] = [];
      let perimeters: any[] = [];
      let perimeterIds: string[] = [];
      orgData.geofences = [];
      const orgPerimeters = (orgPerimetersData?.rows || []).filter(
        (orgPerimeter: any) => orgPerimeter.organizationId === orgData.id
      );
      if(this.data.myCampusBuildingPerimeters.length > 0){
        const orgPerimeterIds = [
          ...new Set(
            campusBuildingPerimeters.flatMap((i: any) =>
              [i.campusId, i.buildingId].map(String)
            )
          )
        ];

        perimeters = (perimeter?.rows || []).filter((p: any) => {
          if (orgPerimeterIds.includes(String(p.id))) {
            return true;
          }

          if (Array.isArray(p.ancestors) && p.ancestors.length > 0) {
            return p.ancestors.some((a: any) =>
              orgPerimeterIds.includes(String(a))
            );
          }

          return false;
        });

        perimeterIds = perimeters.map((p: any) => p.id);

        perimeters = perimeters.map((perimeter: any) => {
          perimeter.beacons = this.collectPerimeterBeacons(
            perimeter,
            results.BeaconFindAndCountAll?.rows || []
          );
          if (perimeter.type === 'CAMPUS') {
            perimeter.campus = this.findAssociatedCampus(
              perimeter.id,
              results.BuildingFindAndCountAll?.rows || []
            );
            if (perimeter.campus) {
              facilities.push(perimeter);
            }
          }
          if (perimeter.type === 'FLOOR') {
            perimeter.floor = this.findAssociatedFloor(
              perimeter.id,
              results.FloorFindAndCountAll?.rows || []
            );
            if (perimeter.floor) {
              perimeter.floor.floorPlanObject = this.findFloorplan(
                results.FloorPlanFindAndCountAll?.rows || [],
                perimeter.floor.id
              );
            }
          } else if (perimeter.type === 'BUILDING') {
            perimeter.building = this.findAssociatedBuilding(
              perimeter.id,
              results.BuildingFindAndCountAll?.rows || []
            );
            if (perimeter.building) {
              facilities.push(perimeter);
            }
          }
          perimeter.pocs = (results.PerimeterContactFindAndCountAll?.rows || [])
            .filter((item: any) => item.perimeterId === perimeter.id)
            .map((item: any) => ({ userId: item.userId, label: item.label }));

          this.data.papiPerimeters[perimeter.id] = perimeter;
          return perimeter;
        });
        perimeters = perimeters.filter(
          (perimeter: any) =>
            (perimeter.type === 'CAMPUS' && perimeter.campus) || (perimeter.type === 'FLOOR' && perimeter.floor) ||
            (perimeter.type === 'BUILDING' && perimeter.building) ||
            perimeter.type === 'ROOM'
        );

        (results.PerimeterSafezoneFindAndCountAll?.rows || []).forEach(
          (perimeterSafezone: any) => {
            if (perimeterIds.includes(perimeterSafezone.perimterId)) {
              safezones.push(perimeterSafezone);
            }
          }
        );

        facilities.forEach((facility: any) => {
          (results.GeofenceFindAndCountAllFromOrganization?.rows || []).forEach(
            (geofence: any) => {
              if (geofence.perimeterGeofenceId === facility.id) {
                orgData.geofences.push(geofence);
              }
            }
          );
        });
      } else if (orgPerimeters.length > 0) {
        const orgPerimeterIds = orgPerimeters.map((p: any) => p.perimeterId);

        perimeters = (perimeter?.rows || []).filter((perimeter: any) => {
          if (orgPerimeterIds.includes(perimeter.id)) {
            return true;
          } else if (
            Array.isArray(perimeter.ancestors) &&
            perimeter.ancestors.length > 0
          ) {
            return perimeter.ancestors.some((ancestorId: string) =>
              orgPerimeterIds.includes(ancestorId)
            );
          }
          return false;
        });

        perimeterIds = perimeters.map((p: any) => p.id);

        perimeters = perimeters.map((perimeter: any) => {
          perimeter.beacons = this.collectPerimeterBeacons(
            perimeter,
            results.BeaconFindAndCountAll?.rows || []
          );
          // if (perimeter.type === 'CAMPUS') {
          //   perimeter.campus = this.findAssociatedCampus(
          //     perimeter.id,
          //     results.BuildingFindAndCountAll?.rows || []
          //   );
          //   if (perimeter.campus) {
          //     facilities.push(perimeter);
          //   }
          // }
          if (perimeter.type === 'FLOOR') {
            perimeter.floor = this.findAssociatedFloor(
              perimeter.id,
              results.FloorFindAndCountAll?.rows || []
            );
            if (perimeter.floor) {
              perimeter.floor.floorPlanObject = this.findFloorplan(
                results.FloorPlanFindAndCountAll?.rows || [],
                perimeter.floor.id
              );
            }
          } else if (perimeter.type === 'BUILDING') {
            perimeter.building = this.findAssociatedBuilding(
              perimeter.id,
              results.BuildingFindAndCountAll?.rows || []
            );
            if (perimeter.building) {
              facilities.push(perimeter);
            }
          }
          perimeter.pocs = (results.PerimeterContactFindAndCountAll?.rows || [])
            .filter((item: any) => item.perimeterId === perimeter.id)
            .map((item: any) => ({ userId: item.userId, label: item.label }));

          this.data.papiPerimeters[perimeter.id] = perimeter;
          return perimeter;
        });
        perimeters = perimeters.filter(
          (perimeter: any) =>
            (perimeter.type === 'CAMPUS' && perimeter.campus) || (perimeter.type === 'FLOOR' && perimeter.floor) ||
            (perimeter.type === 'BUILDING' && perimeter.building) ||
            perimeter.type === 'ROOM'
        );

        (results.PerimeterSafezoneFindAndCountAll?.rows || []).forEach(
          (perimeterSafezone: any) => {
            if (perimeterIds.includes(perimeterSafezone.perimterId)) {
              safezones.push(perimeterSafezone);
            }
          }
        );

        facilities.forEach((facility: any) => {
          (results.GeofenceFindAndCountAllFromOrganization?.rows || []).forEach(
            (geofence: any) => {
              if (geofence.perimeterGeofenceId === facility.id) {
                orgData.geofences.push(geofence);
              }
            }
          );
        });
      }

      const orgSOPs = this.getMySOPs(orgData.id, orgPerimetersData.rows);

      const orgContacts = (
        results.OrganizationContactFindAndCountAll?.rows || []
      )
        .filter((item: any) => item.organizationId === orgData.id)
        .map((item: any) => item.userId);

      const group = (results.group?.data?.rows || []).find(
        (g: any) => g.id === orgData.groupId
      );
      const orgType = group ? group.name : null;

      const myOrg = {
        id: orgData.id,
        name: orgData.name,
        orgType,
        orgContacts,
        createdAt: orgData.createdAt,
        updatedAt: orgData.updatedAt,
        safezones,
        perimeterIds,
        facilities,
        perimeters,
        orgSOPs,
        orgData,
        multi: true,
        ancestors: orgData.ancestors,
        descendants: orgData.descendants,
      };
      myOrg.orgData.attributes = { name: orgData.name };
      mydata.myOrgs[orgData.id] = myOrg;
    });
    _.forEach(mydata.myOrgs, (orgData: any) => {
      const buildingLocations = this.buildingPointLocations(results,
        orgData.perimeters,
        orgData.id
      );
      const campusLocations = this.campusPointLocations(results,
        orgData.perimeters,
        orgData.id
      );
      const entityLocations = [...buildingLocations, ...campusLocations];
      orgData.entityLocations = entityLocations;
      entityLocations.forEach((buildingLocation: any) => {
        const facilityPin = new FacilityPinMapEntity(
          buildingLocation.label,
          buildingLocation.geometry.coordinates[1],
          buildingLocation.geometry.coordinates[0],
          buildingLocation,
          this.coreService,
          this.windowService,
          this.dataContextService,
          this.modalService,
          this.timelineService,
          this.threeJsBuildingIntegration
        );
        if (
          buildingLocation.attributes &&
          buildingLocation.attributes.bluetooth
        ) {
          this.data.myBluetoothFacilityPins[buildingLocation.id] = facilityPin;
        }
        this.data.myFacilityPins[buildingLocation.id] = facilityPin;
        const perimeter = this.findPerimeter(
          mydata.myOrgs,
          buildingLocation.attributes.basePerimeterId
        );
        if (perimeter) {
          const newPerimeterEntity = new PerimeterMapEntity(
            perimeter.id,
            perimeter.label,
            this.flipLocations(perimeter.geometry.coordinates[0]),
            perimeter.updatedAt,
            orgData.id,
            0,
            0,
            perimeter.floor?.id || null,
            perimeter.type,
            perimeter.ancestors,
            '',
            this.cameraService,
            perimeter.attributes || {},
            this.coresService,
            this.coreService,
            this.windowService,
            this.dataContextService,
            this.modalService,
            this.timelineService
          );

          this.data.myPerimeters[perimeter.id] = newPerimeterEntity;
          this.data.myPerimetersForOrg.push({
            organizationId: orgData.id,
            perimeterId: perimeter.id,
          });
          this.foreverEntitiesAdded.perimeters[perimeter.id] =
            newPerimeterEntity;

          if (perimeter.type === 'CAMPUS' || buildingLocation.locationType === 'campus') {
            this.dataContextService.addMapEntity(newPerimeterEntity);
          }
        }

        // if (facilityPin) {
        //   this.dataContextService.addMapEntity(facilityPin);
        // }
      });
    });

    this.data.myFirstOrg = mydata.myOrgs[Object.keys(mydata.myOrgs)[0]];
    // const perimeterResults = this.arcAngelPapiService.setPerimeters(mydata.myOrgs);
    const perimeterResults = this.setPerimeters(mydata.myOrgs);
    // this.setFacilities(mydata.myOrgs, results, mydata);
    this._myPerimetersForOrg = this.data.myPerimetersForOrg;
    this.myOrgs = mydata.myOrgs;
    await this.setFacilityPins(mydata.myOrgs, this.data, results);
    await this.setCampusPins(mydata.myOrgs, this.data, results);
    this.threeJsBuildingIntegration.activate3DVisualizationForBuilding(this.foreverEntitiesAdded.facilities);
    return perimeterResults;
  }
  // here we are setting the organization perimeters

  setPerimeters(orgs: any[]): any[] {
    const perimeterResults: any[] = [];
    _.forEach(orgs, (org: any) => {
      org.perimeters.forEach((perimeter: any) => {
        if (perimeter.type === 'CAMPUS') {
          if (this.foreverEntitiesAdded.perimeters[perimeter.id]) {
            return;
          }
          if (perimeter.geometry?.coordinates?.[0]) {
            const mapPerimeter = new PerimeterMapEntity(
              perimeter.id,
              perimeter.label,
              this.flipLocations(perimeter.geometry.coordinates[0]),
              perimeter.updatedAt,
              org.id,
              0,
              0,
              null,
              perimeter.type,
              perimeter.ancestors,
              '',
              this.cameraService,
              perimeter.attributes || {},
              this.coresService,
              this.coreService,
              this.windowService,
              this.dataContextService,
              this.modalService,
              this.timelineService
            );
            this.foreverEntitiesAdded.perimeters[perimeter.id] = mapPerimeter;
            this.data.myPerimeters[perimeter.id] = mapPerimeter;
            this.dataContextService.addMapEntity(mapPerimeter);
            perimeterResults.push(mapPerimeter);
          }
        } else if (perimeter.type === 'FLOOR' || perimeter.type === 'ROOM') {
          // Find the floor for elevation
          const floor =
            perimeter.type === 'FLOOR'
              ? perimeter.floor
              : this.findPerimeter(orgs, perimeter.parentId)?.floor;

          let elevation = floor ? floor.elevation + 1.0 : 1.0;
          if (perimeter.floor?.parentPerimeterId) {
            elevation += 0.1;
          }
          const alt = elevation + 0.1;

          // Avoid duplicate entities
          if (this.foreverEntitiesAdded.perimeters[perimeter.id]) {
            return;
          }

          // Create the perimeter entity
          const mapPerimeter = new PerimeterMapEntity(
            perimeter.id,
            perimeter.label,
            this.flipLocations(perimeter.geometry.coordinates[0]),
            perimeter.updatedAt,
            org.id,
            alt,
            elevation,
            perimeter.floor?.id || null,
            perimeter.type,
            perimeter.ancestors,
            '',
            this.cameraService,
            perimeter.attributes || {},
            this.coresService,
            this.coreService,
            this.windowService,
            this.dataContextService,
            this.modalService,this.timelineService
          );

          // Set beacons
          if (perimeter.beacons && perimeter.beacons.length > 0) {
            mapPerimeter.setBeacons(perimeter.beacons);
            if (mapPerimeter.beacons) {
              _.forEach(mapPerimeter.beacons, (beacon) => {
                this.data.myBeaconsById[beacon.id] = beacon;
                this.data.myBeacons[beacon.id] = mapPerimeter;
                // this.userPapiService.addReferenceBeacon(beacon, alt); // implement if needed
                // Register reference beacon for Cesium 3D view
                if (
                  typeof methods !== 'undefined' &&
                  typeof methods.addReferenceBeacon === 'function'
                ) {
                  methods.addReferenceBeacon(beacon, elevation);
                }
              });
            }
          }

          // Add to collections
          const sensors = this.collectPerimeterSensors(perimeter);
          this.getSensors(sensors, mapPerimeter);
          this.foreverEntitiesAdded.perimeters[perimeter.id] = mapPerimeter;
          this.data.myPerimeters[perimeter.id] = mapPerimeter;
          // this.dataContextService.addMapEntity(mapPerimeter);
          perimeterResults.push(mapPerimeter);
        }
      });
    });
    return perimeterResults;
  }
  collectPerimeterSensors(perimeter: any): any[] {
    return (this.data.allSensors || []).filter(
      (sensor: any) => sensor.perimeterId === perimeter.id
    );
  }

  getSensors(sensors: any[], perimeter: any): void {
    const sensorIds: string[] = [];

    if (sensors && perimeter) {
      sensors.forEach((sensorData: any) => {
        // Ensure unique sensor ID
        sensorData._id = this.guid();
        const sensor = new Sensor(sensorData, perimeter);
        this.data.mySensors = this.data.mySensors || {};
        this.data.mySensors[sensor.getId()] = sensor;
        sensorIds.push(sensor.getId());

        if (sensor.getType() === 'camera') {
          const meta = sensor.getMetaData();
          // const newfeed = new FmvFeed(
          //   meta.name,
          //   'img/fmvfeed.svg',
          //   true,
          //   meta.url,
          //   meta.type,
          //   false
          // );

          // this.data.mySensorFeeds = this.data.mySensorFeeds || {};
          // if (!this.data.mySensorFeeds[sensor.getId()]) {
          //   Feeds.methods.addFeed(newfeed);
          // } else {
          //   newfeed.id = this.data.mySensorFeeds[sensor.getId()].getId();
          //   Feeds.methods.updateFeed(
          //     this.data.mySensorFeeds[sensor.getId()].getId(),
          //     newfeed
          //   );
          // }

          //this.data.mySensorFeeds[sensor.getId()] = newfeed;
        }
      });
    }

    if (perimeter) {
      perimeter.setSensorIds(sensorIds);
    }
  }

  guid(): string {
    // Simple GUID generator for demonstration; replace with a better one if needed
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

 
  public async setBuildingData(
    facilityId: string,
    buildingSettings: any,
    buildingMapEntity: any,
    orgId: string
  ): Promise<void> {
    try {
      if (buildingSettings.tile) {
        await this.buildingTilesService.loadTileForFacility(
          facilityId,
          buildingSettings.tile,
          buildingMapEntity
        );
      } else {
      }
    } catch (error) {
      console.error('BuildingTilesService setBuildingData error', error);
      throw error;
    }
  }

  // for finding the parimeter
  findPerimeter(orgs: any, perimeterId: string): any | null {
    if (!orgs || !perimeterId) return null;

    const orgList = Array.isArray(orgs) ? orgs : Object.values(orgs);

    for (const org of orgList) {
      if (!org.perimeters) continue;

      for (const perimeter of org.perimeters) {
        if (perimeter.id === perimeterId) {
          return perimeter;
        }
      }
    }

    return null;
  }
  // Flip longitude and latitude in locations
  flipLocations(locations: Array<[number, number, number?]>): number[][] {
    return locations.map(([lng, lat, alt]: [number, number, number?]) => {
      const flipped = [lat, lng];
      if (alt !== undefined) {
        flipped.push(alt);
      }
      return flipped;
    });
  }

  // Helper methods
  collectPerimeterBeacons(perimeter: any, allBeacons: any[]): any[] {
    let perimeterBeacons = (allBeacons || []).filter(
      (beacon) =>
        perimeter.id === beacon.perimeterId ||
        perimeter.parentPerimeterId === beacon.perimeterId
    );
    // Map geometry property
    perimeterBeacons = perimeterBeacons.map((beacon) => ({
      ...beacon,
      geometry: beacon.position, // tincan code wants geometry
    }));

    return perimeterBeacons;
  }
  findAssociatedFloor(perimeterId: string, floors: any[]): any {
    floors = floors || [];
    return _.find(floors, (floor) => {
      return floor.perimeterId === perimeterId;
    });
  }
  findFloorplan(floorplans: any[], floorId: string): any {
    floorplans = floorplans || [];
    return _.find(floorplans, (floorplan) => {
      return floorplan.floorId === floorId;
    });
  }
  findAssociatedBuilding(perimeterId: string, allBuildings: any[]): any {
    allBuildings = allBuildings || [];
    return _.find(allBuildings, (building) => {
      return building.perimeterId === perimeterId;
    });
  }
  findAssociatedCampus(perimeterId: string, allCampus: any[]): any {
    allCampus = allCampus || [];
    return _.find(allCampus, (campus) => {
      return campus.perimeterId === perimeterId;
    });
  }
  getMySOPs(orgId: string, SOPs: any[]): any[] {
    if (!Array.isArray(SOPs)) return [];
    return SOPs.filter((sop) => sop.organization === orgId);
  }
  // Prepare location data for remotes and buildings
  buildingPointLocations(results: any, orgPerimeters: any[], orgId: string) {
    orgPerimeters = orgPerimeters || [];
    return orgPerimeters
      .filter((perimeter) => perimeter.type === 'BUILDING')
      .map((perimeter) => {
        const orgPerimeterMap = _.keyBy(results.orgPerimeters.rows, 'perimeterId')
        const perimeterOrgId = orgPerimeterMap[perimeter.id]?.organizationId || null;
        const polygon = turf.polygon(perimeter.geometry.coordinates);
        const buildingCenterMass = turf.centerOfMass(polygon);
        const buildingRecord = perimeter.building || {
          id: perimeter.id,
          address: '',
        };

        return {
          label: perimeter.label,
          locationType: 'facility',
          attributes: {
            bluetooth: true,
            facilityId: buildingRecord.id,
            basePerimeterId: perimeter.id,
            own: false,
            sops: ['@TODO PAPI does not have facility.sops'],
            poc: perimeter.pocs,
            address: buildingRecord.address,
            ratings: {},
            weatherIndicator: undefined,
            extraInformation: undefined,
          },
          geometry: buildingCenterMass.geometry,
          organizationId: perimeterOrgId,
          createdBy: '',
          id: perimeter.id,
          buildingId: buildingRecord.id,
          createdAt: perimeter.createdAt,
          updatedAt: perimeter.updatedAt,
          archived: false,
        };
      });
  }
  campusPointLocations(results: any, orgPerimeters: any[], orgId: string) {
    orgPerimeters = orgPerimeters || [];

    return orgPerimeters
      .filter((perimeter) => perimeter.type === 'CAMPUS')
      .map((perimeter) => {
        const orgPerimeterMap = _.keyBy(results.orgPerimeters.rows, 'perimeterId')
        const perimeterOrgId = orgPerimeterMap[perimeter.id]?.organizationId || null;
        const polygon = turf.polygon(perimeter.geometry.coordinates);
        const buildingCenterMass = turf.centerOfMass(polygon);
        const buildingRecord = perimeter.campus || {
          id: perimeter.id,
          address: '',
        };

        return {
          label: perimeter.label,
          locationType: 'campus',
          attributes: {
            bluetooth: true,
            facilityId: buildingRecord.id,
            basePerimeterId: perimeter.id,
            own: false,
            sops: ['@TODO PAPI does not have facility.sops'],
            poc: perimeter.pocs,
            address: buildingRecord.address,
            ratings: {},
            weatherIndicator: undefined,
            extraInformation: undefined,
          },
          geometry: buildingCenterMass.geometry,
          organizationId: perimeterOrgId,
          createdBy: '',
          id: perimeter.id,
          buildingId: buildingRecord.id,
          createdAt: perimeter.createdAt,
          updatedAt: perimeter.updatedAt,
          archived: false,
        };
      });
  }
  async setCampusPins(myOrgs: any, data: any, results: any) {
    try {
      const buildingPromises = [];
      this.foreverEntitiesAdded.campus = {};
      
      const orgPerimeterMap = _.keyBy(results.orgPerimeters.rows, 'perimeterId');
      _.forEach(myOrgs, (org) => {
        org.perimeters
          .filter((perimeter: any) => {
            return perimeter.type === 'CAMPUS';
          })
           .forEach((buildingPerimeter: any) => {
            
            const assignedOrgId =
              orgPerimeterMap[buildingPerimeter.id]?.organizationId || null;
            // Collect floor objects associated with this building
            // const floors = org.perimeters.filter((f: any) => {
            //   if (f.type === 'FLOOR' && !f.ancestors) {
            //     return false;
            //   }
            //   return (
            //     f.type === 'FLOOR' && f.ancestors.includes(buildingPerimeter.id)
            //   );
            // });

            let buildingView = results.BuildingViewFindAndCountAll.rows.find(
              (view: any) => view.buildingId === buildingPerimeter?.campus?.id
            );

            if (!buildingView) {
              buildingView = {
                heading: 0,
                height: 5000,
                pitch: -0.1,
                range: 750,
              };
            }

            // Find the tile record (empty object if doesn't exist)
            const buildingTile =
              results.BuildingTileFindAndCountAll.rows.find(
                (tile: any) => tile.buildingId === buildingPerimeter?.campus?.id
              ) || {};

            if (
              !(buildingPerimeter.id in this.foreverEntitiesAdded.campus)
            ) {
              // Grab center of building poly
              const polygon = turf.polygon(
                buildingPerimeter.geometry.coordinates
              );
              const buildingCenterMass = turf.centerOfMass(polygon);

              const baseViewLon = buildingPerimeter.campus.position
                ? buildingPerimeter.campus.position.coordinates[0]
                : buildingCenterMass.geometry.coordinates[0];
              const baseViewLat = buildingPerimeter.campus.position
                ? buildingPerimeter.campus.position.coordinates[1]
                : buildingCenterMass.geometry.coordinates[1];

              const arcliveweb = {
                baseViewLon,
                baseViewLat,
                baseViewHeading: buildingView.heading,
                baseViewHeight: buildingView.height,
                baseViewPitch: buildingView.pitch,
                baseViewRange: buildingView.range,
                buildingId: buildingTile.definitionBuildingId,
                relationId: buildingTile.definitionRelationId,
                tile: buildingTile.definition,
              };

              const buildingEntity = new BuildingMapEntity(
                buildingPerimeter.label,
                arcliveweb.buildingId,
                arcliveweb.relationId,
                [],
                data.fixCameraOnFacility,
                buildingPerimeter.id,
                this.cameraService,
                this.coreService,
                this.windowService,
                this.dataContextService,
                this.modalService,
                this.timelineService,
                this
              );

              buildingEntity.assignedOrgId = assignedOrgId;
              buildingEntity.setBottomCameraView(
                arcliveweb.baseViewLat,
                arcliveweb.baseViewLon,
                arcliveweb.baseViewRange,
                arcliveweb.baseViewHeading,
                arcliveweb.baseViewPitch,
                arcliveweb.baseViewHeight
              );

              this.foreverEntitiesAdded.campus[buildingPerimeter.id] =
                buildingEntity;
              data.myBuildings.push(buildingEntity);
              this.dataContextService.addMapEntity(buildingEntity);
              this.foreverEntitiesAdded.campus[
                buildingPerimeter.id
              ].addAssociatedOrg(org.id);

              let campusPerimeterEntity = this.foreverEntitiesAdded.perimeters[buildingPerimeter.id];
              if (!campusPerimeterEntity && buildingPerimeter.geometry?.coordinates?.[0]) {
                campusPerimeterEntity = new PerimeterMapEntity(
                  buildingPerimeter.id,
                  buildingPerimeter.label,
                  this.flipLocations(buildingPerimeter.geometry.coordinates[0]),
                  buildingPerimeter.updatedAt,
                  org.id,
                  0,
                  0,
                  null,
                  'CAMPUS',
                  buildingPerimeter.ancestors,
                  '',
                  this.cameraService,
                  buildingPerimeter.attributes || {},
                  this.coresService,
                  this.coreService,
                  this.windowService,
                  this.dataContextService,
                  this.modalService,
                  this.timelineService
                );
                this.data.myPerimeters[buildingPerimeter.id] = campusPerimeterEntity;
                this.foreverEntitiesAdded.perimeters[buildingPerimeter.id] = campusPerimeterEntity;
              }
              if (campusPerimeterEntity) {
                this.dataContextService.addMapEntity(campusPerimeterEntity);
                buildingEntity.addBuildingRelationEntity(campusPerimeterEntity);
              }

              if (data.myBluetoothFacilityPins[buildingPerimeter.id]) {
                data.myBluetoothFacilityPins[
                  buildingPerimeter.id
                ].setBuildingMapEntity(buildingEntity);
                buildingEntity.setAssociatedPin(
                  data.myBluetoothFacilityPins[buildingPerimeter.id]
                );
              }
              buildingEntity.type = 'CampusMapEntity';
              const campusesList = Array.isArray(data.myCampus) ? data.myCampus : (data.myCampus?.campuses || []);
              const currentCampusData = campusesList.find((c: any) => String(c.campusId) === String(buildingPerimeter.id));

              const campusBuildingIds = new Set(
                currentCampusData?.buildings?.map((b: any) => String(b.buildingId)) || []
              );

              buildingEntity.associatedBuilding =
                data?.myBuildings?.filter((building: any) =>
                  campusBuildingIds.has(String(building.perimeterId))
                ) || [];
                if (buildingEntity.associatedBuilding && buildingEntity.associatedBuilding.length > 0) {
                  buildingEntity.associatedBuilding.forEach((b: any) => {
                    b.associatedcampus = {
                      id: buildingPerimeter.id,
                      name: buildingPerimeter.label
                    };
                  });
                }

               // this.setAreas(org, buildingPerimeter, floors, data);
              this.foreverEntitiesAdded.campus[
                buildingPerimeter.id
              ].setAreaEntities(
                this.getAreas(
                  this.foreverEntitiesAdded.campus[
                    buildingPerimeter.id
                  ].getAreaIds()
                )
              );
              if (
                this.buildingTilesService &&
                typeof this.setBuildingData === 'function'
              ) {
                buildingPromises.push(
                  this.setBuildingData(
                    buildingPerimeter.id,
                    arcliveweb,
                    buildingEntity,
                    org.id
                  )
                );
              }
            }
          });
      });
    } catch (error) {
      console.error('Error setting facility pins:', error);
    }
  }
  /// here we are creating the facilities
  async setFacilityPins(myOrgs: any, data: any, results: any) {
    try {
      const buildingPromises: any[] = [];
      this.foreverEntitiesAdded.facilities = {};

      // Create fast lookup map for perimeter -> organization
      const orgPerimeterMap = _.keyBy(results.orgPerimeters.rows, 'perimeterId');

      _.forEach(myOrgs, (org) => {
        org.perimeters
          .filter((perimeter: any) => perimeter.type === 'BUILDING')
          .forEach((buildingPerimeter: any) => {
            const assignedOrgId =
              orgPerimeterMap[buildingPerimeter.id]?.organizationId || null;
            // Collect floor objects associated with this building
            const floors = org.perimeters.filter((f: any) => {
              if (f.type === 'FLOOR' && !f.ancestors) {
                return false;
              }
              return (
                f.type === 'FLOOR' && f.ancestors.includes(buildingPerimeter.id)
              );
            });

            let buildingView = results.BuildingViewFindAndCountAll.rows.find(
              (view: any) => view.buildingId === buildingPerimeter.building.id
            );

            if (!buildingView) {
              buildingView = {
                heading: 0,
                height: 500,
                pitch: -0.1,
                range: 750,
              };
            }

            // Find the tile record (empty object if doesn't exist)
            const buildingTile =
              results.BuildingTileFindAndCountAll.rows.find(
                (tile: any) => tile.buildingId === buildingPerimeter.building.id
              ) || {};

            if (
              !(buildingPerimeter.id in this.foreverEntitiesAdded.facilities)
            ) {
              // Grab center of building poly
              const polygon = turf.polygon(
                buildingPerimeter.geometry.coordinates
              );
              const buildingCenterMass = turf.centerOfMass(polygon);

              const baseViewLon = buildingPerimeter.building.position
                ? buildingPerimeter.building.position.coordinates[0]
                : buildingCenterMass.geometry.coordinates[0];
              const baseViewLat = buildingPerimeter.building.position
                ? buildingPerimeter.building.position.coordinates[1]
                : buildingCenterMass.geometry.coordinates[1];

              const arcliveweb = {
                baseViewLon,
                baseViewLat,
                baseViewHeading: buildingView.heading,
                baseViewHeight: buildingView.height,
                baseViewPitch: buildingView.pitch,
                baseViewRange: buildingView.range,
                buildingId: buildingTile.definitionBuildingId,
                relationId: buildingTile.definitionRelationId,
                tile: buildingTile.definition,
              };

              const buildingEntity = new BuildingMapEntity(
                buildingPerimeter.label,
                arcliveweb.buildingId,
                arcliveweb.relationId,
                floors.map((f: any) => f.id),
                data.fixCameraOnFacility,
                buildingPerimeter.id,
                this.cameraService,
                this.coreService,
                this.windowService,
                this.dataContextService,
                this.modalService,
                this.timelineService,
                this
              );
              buildingEntity.assignedOrgId = assignedOrgId;

              buildingEntity.setBottomCameraView(
                arcliveweb.baseViewLat,
                arcliveweb.baseViewLon,
                arcliveweb.baseViewRange,
                arcliveweb.baseViewHeading,
                arcliveweb.baseViewPitch,
                arcliveweb.baseViewHeight
              );

              this.foreverEntitiesAdded.facilities[buildingPerimeter.id] =
                buildingEntity;
              data.myBuildings.push(buildingEntity);
              this.dataContextService.addMapEntity(buildingEntity);
              this.foreverEntitiesAdded.facilities[
                buildingPerimeter.id
              ].addAssociatedOrg(org.id);

              if (data.myBluetoothFacilityPins[buildingPerimeter.id]) {
                data.myBluetoothFacilityPins[
                  buildingPerimeter.id
                ].setBuildingMapEntity(buildingEntity);
                buildingEntity.setAssociatedPin(
                  data.myBluetoothFacilityPins[buildingPerimeter.id]
                );
              }
              buildingEntity.type = 'BuildingMapEntity';
              this.setAreas(org, buildingPerimeter, floors, data);
              this.foreverEntitiesAdded.facilities[
                buildingPerimeter.id
              ].setAreaEntities(
                this.getAreas(
                  this.foreverEntitiesAdded.facilities[
                    buildingPerimeter.id
                  ].getAreaIds()
                )
              );
              if (
                this.buildingTilesService &&
                typeof this.setBuildingData === 'function'
              ) {
                buildingPromises.push(
                  this.setBuildingData(
                    buildingPerimeter.id,
                    arcliveweb,
                    buildingEntity,
                    org.id
                  )
                );
              }
            }
          });
      });
      await Promise.all(buildingPromises);
    } catch (error) {
      console.error('Error setting facility pins:', error);
    }
  }
  setAreas(org: any, building: any, areas: any[], data: any): void {
    areas.forEach((areaData: any) => {
      if (!(areaData.id in this.foreverEntitiesAdded.areas)) {
        if (!areaData.floor) {
          return;
        }
        const newArea = new AreaMapEntity(
          areaData.id,
          areaData.label,
          this.flipLocations(areaData.geometry.coordinates[0]),
          areaData.floor.elevation,
          areaData.floor.elevation + 1.5,
          this.coreService,
          this.windowService,
          this.dataContextService,
          this.modalService,this.timelineService
        );

        const floorplanobj =
          areaData.floor.floorPlanObject || areaData.floorPlan;

        if (floorplanobj) {
          newArea.setFloorPlan(
            `${ConfigurationManagerService.settings.BaseURL}/Floorplan/${floorplanobj.id}/file`
          );
          newArea.floorplanId = floorplanobj.id;
          const coordinates = [
            floorplanobj.topLeft.coordinates,
            floorplanobj.topRight.coordinates,
            floorplanobj.bottomLeft.coordinates,
          ];
          newArea.setFloorPlanRotationCoords(coordinates);
        }
        newArea.setFloorNumber(areaData.floor.number);
        newArea.setShowInOverlappingEntitiesUI(false);

        // build list of the floor itself and all rooms on this floor
        const floorAndRooms = org.perimeters.filter(
          (perimeter: any) =>
            perimeter.id === areaData.id || perimeter.parentId === areaData.id
        );

        // collect Perimeter objects so we can attach to (Area)Floor
        const perimeters: any[] = [];
        floorAndRooms.forEach((perimeter: any) => {
          if (this.foreverEntitiesAdded.perimeters[perimeter.id]) {
            perimeters.push(this.foreverEntitiesAdded.perimeters[perimeter.id]);
            data.perimeterAreaMap[perimeter.id] = newArea;
          }
        });
        newArea.setPerimeters(perimeters);
        this.foreverEntitiesAdded.areas[areaData.id] = newArea;
        // this.dataContextService.addMapEntity(newArea);
      }
    });
  }
  getAreas(areaIds: string[]): any[] {
    return areaIds.map((id) => this.getArea(id)).filter((area) => !!area);
  }
  getArea(areaId: string) {
    return this.foreverEntitiesAdded.areas[areaId];
  }
  getIncidentCategoryInfo(
    organizationId: string
  ): Observable<Record<string, IncidentCategory[]>> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.findAllWithIncidentCategory;
    // '/api/organizationIncidentCategoryFindWithIncidentCategory'
    const param = {
      where: { organizationId },
      incidentCategoryWhere: { type: 'INCIDENT' },
      incidentCategoryAttributes: [
        'id',
        'label',
        'description',
        'public',
        'iconCode',
      ],
    };
    // Replace with your actual API endpoint and logic
    return this.api
      .post<any>(url, param)
      .pipe(
        map((response: any) => this.transformOrgIncCatWithIncCats(response))
      );
  }

  // You must implement this transformation logic as needed
  public transformOrgIncCatWithIncCats(
    orgIncCatWithIncCats: any[]
  ): Record<string, any[]> {
    // Flatten and normalize the list
    const flatList = _.map(orgIncCatWithIncCats, (oicwic) => ({
      id: oicwic.id,
      organizationId: oicwic.organizationId,
      incidentCategoryId: oicwic.IncidentCategory?.id,
      iconCode: oicwic.IncidentCategory?.iconCode,
      label: oicwic.IncidentCategory?.label,
      description: oicwic.IncidentCategory?.description,
      public: oicwic.IncidentCategory?.public,
    }));
    // Group by organizationId
    const dict = _.groupBy(flatList, 'organizationId');
    return dict;
  }

  // Helper to get descendants (mimics legacy getOrgDescendants)
  private getOrgDescendants(orgIds: string[]): string[] {
    orgIds = orgIds || [];
    const myOrgs = this.myOrgs || {};
    return _.uniq(
      _.concat(
        orgIds,
        _.flatten(
          orgIds.map((orgId) =>
            myOrgs[orgId] && myOrgs[orgId].descendants
              ? myOrgs[orgId].descendants
              : []
          )
        )
      )
    );
  }

  public getOrgsAvailForIncident(perimeterId: string): Observable<string[]> {
    const params = { attributes: ['organizationId'], where: { perimeterId } };
    const url1 =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.OrganizationPerimeterFindAndCountAll;
    const url2 =
      ConfigurationManagerService.settings.BaseURL +
      'db/Action/sessionWithOrganizationIds';

    return this.api.post<any>(url1, params).pipe(
      switchMap((response) => {
        // Step 1: Get orgIds for perimeter and descendants
        const orgIds = (response.rows || []).map(
          (row: any) => row.organizationId
        );
        const descendantOrgIds = this.getOrgDescendants(orgIds);

        // Step 2: Get orgs with permission to create incidents
        const actionSessionParams = {
          attributes: ['id'],
          where: {
            $or: [
              { code: 'papi.db.Incident.createPerimeter' },
              { code: 'papi.db.Incident.createPerimeterPublic' },
            ],
          },
        };
        return this.api.post<any>(url2, actionSessionParams).pipe(
          map((response2) => {
            // Step 3: Collect all orgIds user can manage
            let orgIdsUserCanManageIncidents: string[] = [];
            (response2.rows || []).forEach((o: any) => {
              orgIdsUserCanManageIncidents.push(...o.organizationIds);
            });
            orgIdsUserCanManageIncidents = _.uniq(orgIdsUserCanManageIncidents);

            // Step 4: Add descendants
            orgIdsUserCanManageIncidents = this.getOrgDescendants(
              orgIdsUserCanManageIncidents
            );

            // Step 5: Intersection
            return _.intersection(
              descendantOrgIds,
              orgIdsUserCanManageIncidents
            );
          })
        );
      })
    );
  }
  public getAffectedPerimeterEntities(affectedPerimeters: any[]): any[] {
    const list: any[] = [];
    if (affectedPerimeters !== undefined) {
      for (let i = 0; i < affectedPerimeters.length; i++) {
        const perimeterId = affectedPerimeters[i]?.perimeterId;
        const perimeterEntity =
          this.foreverEntitiesAdded.perimeters[perimeterId];
        if (perimeterEntity !== undefined) {
          list.push(perimeterEntity);
        }
      }
    }
    return list;
  }
  // Method to get filtered orgs (excluding specific IDs)
  // getFilteredOrgs(): Organization[] {
  //   const excludedIds = ['1', '2', '7'];
  //   return this.myOrgs.filter((org: any) =>
  //     !excludedIds.includes(org.arcAngelId)
  //   );
  // }

  /**
   * Common message reformatting utility for all components
   */
  public reformat(messages: any[], users: any[], orgs: any[] = []): any[] {
    if (!Array.isArray(messages) || !Array.isArray(users)) return [];

    // 🔑 Pre-index users and orgs into maps
    const userMap: Record<string, string> = {};
    users.forEach((u) => {
      if (u?.id) userMap[String(u.id)] = u.name;
    });

    const orgMap: Record<string, string> = {};
    orgs.forEach((o) => {
      if (o?.id) orgMap[String(o.id)] = o.name;
    });

    const resolveName = (headers: any[], fallback?: string): string => {
      if (!Array.isArray(headers) || headers.length === 0) {
        return fallback ?? 'Application Admin';
      }

      const userHeader = headers.find((h) => h.userId);
      if (userHeader && userMap[userHeader.userId]) {
        return userMap[userHeader.userId];
      }

      return fallback ?? 'Application Admin';
    };

    const resolveOrgName = (headers: any[]): string | null => {
      if (!Array.isArray(headers) || headers.length === 0) return null;
      const orgHeader = headers.find((h) => h.organizationId);
      if (orgHeader) {
        return (
          orgMap[orgHeader.organizationId] ?? `Org-${orgHeader.organizationId}`
        );
      }
      return null;
    };

    const resolveRecipientCount = (headers: any[]): number | null => {
      if (!Array.isArray(headers) || headers.length === 0) return null;
      const countHeader = headers.find((h) => h.recipientCount);
      return countHeader ? Number(countHeader.recipientCount) || 0 : null;
    };

    const buildFromStr = (
      senderUserFullName?: string,
      senderOrganizationName?: string | null,
      headers?: any[]
    ): string => {
      // Extract userId from headers
      const senderUserId = headers?.find((h) => h.userId)?.userId ?? null;

      if (
        senderUserFullName === 'undefined' &&
        senderUserId &&
        senderOrganizationName
      ) {
        return `${senderUserId} (${senderOrganizationName})`;
      } else if (
        senderUserFullName &&
        senderOrganizationName &&
        senderUserFullName !== 'undefined'
      ) {
        return `${senderUserFullName} (${senderOrganizationName})`;
      } else if (senderOrganizationName) {
        return senderOrganizationName;
      } else if (senderUserFullName && senderUserFullName !== 'undefined') {
        return senderUserFullName;
      } else if (senderUserId) {
        return senderUserId;
      } else {
        return '';
      }
    };

    return messages.map((msg) => {
      const fromName = resolveName(msg.FromMessageHeaders, msg.from);
      const toName = resolveName(msg.ToMessageHeaders, msg.to);
      const fromOrgName = resolveOrgName(msg.FromMessageHeaders);
      const toOrgName = resolveOrgName(msg.ToMessageHeaders);
      const localTime = this.getMessageLocalTime(msg);
      const recipientCount = resolveRecipientCount(msg.ToMessageHeaders);
      const fromStr = buildFromStr(
        fromName,
        fromOrgName,
        msg.FromMessageHeaders
      );
      return {
        ...msg,
        from: fromName,
        to: toName,
        fromOrgName,
        toOrgName,
        fromStr,
        localTime,
        subjectStr: msg.subject || (msg.text ? msg.text.slice(0, 30) : ''),
        methodsStr: Array.isArray(msg.methods)
          ? `[${msg.methods.join(', ')}]`.replace('NOTIFICATION', 'DATA')
          : '[]',
        recipientCount,
      };
    });
  }

  public getOrgNameById(orgId: string, orgs: any[]): string | null {
    if (!orgId || !Array.isArray(orgs)) return null;
    const org = orgs.find((o) => String(o.id) === String(orgId));
    return org ? org.name : null;
  }

  /**
   * Get user name by userId from users array
   */
  public getUserNameById(userId: any, users: any[]): string | undefined {
    if (!userId || !Array.isArray(users)) return undefined;
    const user = users.find((u: any) => u.id == userId);
    return user?.name;
  }

  /**
   * Get local time string from message object
   */
  public getMessageLocalTime(msg: any): string {
    if (msg?.ToMessageHeaders?.[0]?.readAt) {
      return new Date(msg.ToMessageHeaders[0].readAt).toLocaleString();
    } else if (msg.created_at) {
      return new Date(msg.created_at).toLocaleString();
    } else if (msg.createdAt) {
      return new Date(msg.createdAt).toLocaleString();
    }
    return '';
  }

  public clearUserData(): void {
    this.myOrgs = {};
    this.data = {
      papiPerimeters: {},
      myBluetoothFacilityPins: {},
      myFacilityPins: {},
      myBuildings: [],
      perimeterAreaMap: {},
      myPerimeters: {},
      myBeaconsById: {},
      myBeacons: {},
      myPerimetersForOrg: [],
      userStatusByIncidentLast: {},
      playbackBuildingViewDataDict: {},
    };
    this.foreverEntitiesAdded = {
      perimeters: {},
      facilities: {},
      remotes: {},
      areas: {},
      campus: {},
    };
    this._myPerimetersForOrg = [];
  }

  // set value
  setCampusState(value: boolean): void {
    this.isCampusIncident.next(value);
  }

  // get current value instantly
  getCampusState(): boolean {
    return this.isCampusIncident.value;
  }
}
